import { render, staticRenderFns } from "./colorPickerDialog.vue?vue&type=template&id=104023f4"
import script from "./colorPickerDialog.vue?vue&type=script&lang=js"
export * from "./colorPickerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports